import { AppForms, Chat } from '@/config'
import {
  AddMembersModalPage,
  AddMembersModalPageProps,
  GroupDetailsModalProps,
} from '@/components'
import { ChatUser, refreshChat } from '@packages/chat'
import { appStatusStore } from '@/stores'

export function AddMembers(props: AddMembersModalPageProps & GroupDetailsModalProps) {
  const { channel } = props

  const memberCount = channel?.data?.member_count || 1
  const availableSlots = Math.min(
    Chat.Constants.maxSelectedMembers,
    Math.max(0, Chat.Constants.maxMembersGroup - memberCount),
  )

  const { query } = Chat.Queries.members.manager.useList({
    queryOptions: {
      enabled: false,
    },
    filter: {
      channelId: channel.id,
    },
  })

  async function addMembers(selectedUsers: ChatUser[]) {
    appStatusStore.set('loading')
    Chat.Services.addMembers({
      channelId: channel.id,
      selectedMembers: selectedUsers,
      onSuccess: async () => {
        props?.toggle()
        query?.refetch()
        AppForms.chatGroup.resetValues()
        refreshChat(selectedUsers.length).finally(() => {
          Chat.Store.setIsRefreshingMembers(false)
          appStatusStore.set('done')
        })
      },
      onError: () => { appStatusStore.set('idle') },
    })
  }

  return (
    <AddMembersModalPage
      {...props}
      buttonProps={{
        text: 'Add',
      }}
      onSave={addMembers}
      maxSelectedUsers={availableSlots}
      filter={{
        exclude_chat: channel.id,
        include_me: false,
      }}
    />
  )
}
